import { SCvalues } from "./commonComponentsTypes";

export const transformArrayDataToSelectOptions = (
  data: Array<any> | undefined
): SCvalues[] => {
  if (!data) return [];
  return data.map((item) => {
    return {
      value: item.id,
      label: item?.name || item?.label || item?.title,
    };
  });
};
